// extracted by mini-css-extract-plugin
export default {"ShareInviteLink":"ShareInviteLink_ShareInviteLink__1zmSw"};